export default __webpack_public_path__ + "static/media/jasperOlieroock.80916738.svg";